import { Component, ElementRef, EventEmitter, HostListener, Output, ViewChild } from '@angular/core';
import { StoreService } from '../store.service';
import { ErrorService } from 'src/app/shared/error.service';
import { FormControl } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { InstantSearchService } from 'src/app/shared/algolia.service';
import { algoliasearch } from 'algoliasearch';
import connectSearchBox from 'instantsearch.js/es/connectors/search-box/connectSearchBox';
import connectHitsPerPage from 'instantsearch.js/es/connectors/hits-per-page/connectHitsPerPage';
import connectHits from 'instantsearch.js/es/connectors/hits/connectHits';
import { Router } from '@angular/router';


const searchClient = algoliasearch(
  environment.algolia.appId,
  environment.algolia.apiKey
);

@Component({
  selector: 'app-main-store-page',
  templateUrl: './main-store-page.component.html',
  styleUrls: ['./main-store-page.component.css']
})

export class MainStorePageComponent {
  @ViewChild('searchContainer') searchContainer!: ElementRef;

  categories: any;
  searchControl = new FormControl('');
  isLoading = false;
  // @Output() search = new EventEmitter<string>();
  results: any[] = [];
  loading = false;
  private searchBox: any;
  private hits: any;
  showDropdown = false;

  config = {
    indexName: environment.algolia.dev_FIRE,
    searchClient,
    insightsClient: (window as any).aa,
  };

  constructor(
    private algoliaService: InstantSearchService,
    private router: Router,
    private storeService: StoreService, public error: ErrorService) {

  }

  @HostListener('document:click', ['$event'])
  clickOut(event: Event) {
    if (!this.searchContainer.nativeElement.contains(event.target)) {
      this.showDropdown = false;
    }
  }

  ngOnInit(): void {
    this.storeService.getCategories()
      .subscribe(categories => {
        this.categories = categories;
      })
    // Initialize search box widget
    this.searchBox = connectSearchBox(
      (renderOptions, isFirstRender) => {
        const { query, refine } = renderOptions;

        if (isFirstRender) {
          this.search = (event: any) => {
            refine(event.target.value);
            this.showDropdown = true;
          };
        }
      }
    );

    // Initialize hits widget
    this.hits = connectHits(
      (renderOptions) => {
        const { hits, isSearchStalled } = renderOptions as any;
        this.results = hits;
        this.loading = isSearchStalled;
      }
    );

    // Add widgets to InstantSearch instance
    this.algoliaService.addWidgets([
      this.searchBox(),
      this.hits()
    ]);

    // Start InstantSearch
    this.algoliaService.start();
  }

  ngOnDestroy() {
    // Remove widgets when component is destroyed
    if (this.searchBox && this.hits) {
      this.algoliaService.removeWidgets([
        this.searchBox(),
        this.hits()
      ]);
    }
  }

  search(event: any) {
    console.log(event);
  }

  clearSearch(): void {
    this.results = [];
    this.showDropdown = false;
    // Trigger the search box refine with empty string
    if (this.searchBox) {
      this.searchBox().refine('');
    }
  }

  selectProduct(product: any) {
    this.router.navigate(['products', product.id])
    this.showDropdown = false;
  }
}
